import useFormContext from "../../../hooks/useFormContext"
import React from "react";
import {translate} from "../../../i18n";
import {useDispatch, useSelector} from "react-redux";

const CompanyInformations = ({fields}) => {
    const { data, handleChange, errors} = useFormContext()
    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.label) || 'togo';
    const countryCode = iso2.toLowerCase();

    const content = (
        <>
                <div className="flex-col">
                    <label htmlFor="companyName">{translate('signup', language_code.lang).companyName}</label>
                    <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        placeholder=""
                        value={data.companyName}
                        onChange={handleChange}
                    />
                    {errors.companyName && <span style={{ color: "red" }}>{errors.companyName}</span>}
                </div>

                <div className="flex-col">
                    <label htmlFor="companyCode">{translate('signup', language_code.lang).companyCode}</label>
                    <input
                        type="text"
                        id="companyCode"
                        name="companyCode"
                        placeholder="TG-DDBV-4865-HDRT-0983"
                        value={data.companyCode}
                        onChange={handleChange}
                    />
                    {errors.companyCode && <span style={{ color: "red" }}>{errors.companyCode}</span>}
                </div>

                <div className="flex-col">
                    <label htmlFor="companySector">{translate('signup', language_code.lang).companySector}</label>
                    <select
                        id="companySector"
                        name="companySector"
                        placeholder="choisir"
                        value={data.companySector}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="public">{translate('company_informations', language_code.lang).company_sector.public}</option>
                        <option value="private">{translate('company_informations', language_code.lang).company_sector.private}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="companyStatus">{translate('signup', language_code.lang).companyStatus}</label>
                    <select
                        id="companyStatus"
                        name="companyStatus"
                        placeholder="choisir"
                        value={data.companyStatus}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="sa">{translate('company_informations', language_code.lang).company_status.sa}</option>
                        <option value="ong">{translate('company_informations', language_code.lang).company_status.ong}</option>
                        <option value="sas">{translate('company_informations', language_code.lang).company_status.sas}</option>
                        <option value="sarl">{translate('company_informations', language_code.lang).company_status.sarl}</option>
                        <option value="scop">{translate('company_informations', language_code.lang).company_status.scop}</option>
                        <option value="gie">{translate('company_informations', language_code.lang).company_status.gie}</option>
                        <option value="ei">{translate('company_informations', language_code.lang).company_status.ei}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="companyAgroRealm">{translate('signup', language_code.lang).companyAgroRealm}</label>
                    <select
                        id="companyAgroRealm"
                        name="companyAgroRealm"
                        placeholder="choisir"
                        value={data.companyAgroRealm}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="vegi_prod">{translate('company_informations', language_code.lang).company_activity_realm.vegi_prod}</option>
                        <option value="pastoral_prod">{translate('company_informations', language_code.lang).company_activity_realm.pastoral_prod}</option>
                        <option value="vegi_indus_transform">{translate('company_informations', language_code.lang).company_activity_realm.vegi_indus_transform}</option>
                        <option value="pasto_indus_transform">{translate('company_informations', language_code.lang).company_activity_realm.pasto_indus_transform}</option>
                        <option value="agroecology">{translate('company_informations', language_code.lang).company_activity_realm.agroecology}</option>
                        <option value="developpement">{translate('company_informations', language_code.lang).company_activity_realm.developpement}</option>
                        <option value="fourniture">{translate('company_informations', language_code.lang).company_activity_realm.fourniture}</option>
                        <option value="com_distribution">{translate('company_informations', language_code.lang).company_activity_realm.com_distribution}</option>
                        <option value="logistique_transport">{translate('company_informations', language_code.lang).company_activity_realm.logistique_transport}</option>
                        <option value="agri_finance_insurance">{translate('company_informations', language_code.lang).company_activity_realm.agri_finance_insurance}</option>
                        <option value="training_education">{translate('company_informations', language_code.lang).company_activity_realm.training_education}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="responsabilityInCompany">{translate('signup', language_code.lang).responsabilityInCompany}</label>
                    <select
                        id="responsabilityInCompany"
                        name="responsabilityInCompany"
                        placeholder="choisir"
                        value={data.responsabilityInCompany}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="director">{translate('roles', language_code.lang).app_user_roles.director}</option>
                        <option value="manager">{translate('roles', language_code.lang).app_user_roles.manager}</option>
                        <option value="it_technician">{translate('roles', language_code.lang).app_user_roles.it_technician}</option>
                        <option value="agri_technician">{translate('roles', language_code.lang).app_user_roles.agri_technician}</option>
                        <option value="accounting">{translate('roles', language_code.lang).app_user_roles.accounting}</option>
                        <option value="production_promoter">{translate('roles', language_code.lang).app_user_roles.production_promoter}</option>
                        <option value="fiels_operator">{translate('roles', language_code.lang).app_user_roles.fiels_operator}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="preferredLanguage">{translate('signup', language_code.lang).preferredLanguage}</label>
                    <select
                        id="preferredLanguage"
                        name="preferredLanguage"
                        placeholder="choisir"
                        value={data.preferredLanguage}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="french">{translate('metadata', language_code.lang).language.french}</option>
                        <option value="english">{translate('metadata', language_code.lang).language.english}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="deliveryAddress">{translate('signup', language_code.lang).deliveryAddress}</label>
                    <input
                        type="text"
                        id="deliveryAddress"
                        name="deliveryAddress"
                        placeholder=""
                        value={data.deliveryAddress}
                        onChange={handleChange}
                    />
                    {errors.deliveryAddress && <span style={{ color: "red" }}>{errors.deliveryAddress}</span>}
                </div>
            </>
    )

    return content
}
export default CompanyInformations